"use strict";
import React, {Component} from "react";
import {templates, PropTypes} from "Subschema";
import {body as className} from "./BodyTemplate.less";

const {FieldSetTemplate} = templates;
const {style, ...propTypes} = FieldSetTemplate.defaultProps;

export default class BodyTemplate extends Component {

    static propTypes = {
        ...FieldSetTemplate.propTypes,
        "backgroundImage": PropTypes.string
    };
    static defaultProps = {
        ...FieldSetTemplate.defaultProps
    };

    render() {
        const {backgroundImage, ...props} = this.props;
        const style = backgroundImage ? {
            backgroundImage: `url("${backgroundImage}")`
        } : null;
        return <div className={className} style={style}>
            <div id="injectedUnifiedLogin" style={{height:"0px", visibility: "hidden", overFlow: "hidden"}}></div>
            <FieldSetTemplate {...props}/>
        </div>
    }
}



/** WEBPACK FOOTER **
 ** ./src/templates/BodyTemplate.jsx
 **/